import { Modal } from 'almanac-ui/Modal'
import { SettingsForm } from 'components/HandbookShare/SettingsForm/SettingsForm'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { HandbookV2 } from 'types'

export const CustomUrl = ({ handbook }: { handbook: HandbookV2 }) => {
  const workspace = useCurrentWorkspace()

  if (!workspace) return null

  return (
    <>
      <Modal.Content>
        <SettingsForm
          originalPath={handbook?.folder?.url || ''}
          workspace={workspace}
          workspaceDomain={workspace.workspace_domain}
        />
      </Modal.Content>
    </>
  )
}
